const adjustPopupHeight = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh100', `${vh}px`);
};

export default adjustPopupHeight;
